import { defineStore } from 'pinia';
import { UserInfo } from '@/types';

interface UserInfoState {
    userInfo: UserInfo | null;
}

const useUserInfoStore = defineStore('userInfo', {
    state: (): UserInfoState => ({
        userInfo: null as UserInfo | null
    }),
    actions: {
        saveUserInfo(userInfo: UserInfo) {
            this.userInfo = userInfo;
        },
        getUserInfo() {
            return this.userInfo;
        },
        hasUserInfo() {
            return !!this.userInfo;
        },
        deleteUserInfo() {
            this.userInfo = null;
        }
    },
    persist: true
});

export default useUserInfoStore;